<template>
  <picture
          ref="pictureRef"
          class="fixed inset-0 m-auto block -z-1 bg-light"
    >
    <media-source
            :uri="imgUri"
            :dimensions="[
                    { width: 3840, height: 2560 },
                    { width: 2560, height: Math.round(2560/1.5) },
                    { width: 1920, height: Math.round(1920/1.5) },
                    { width: 1400, height: Math.round(1400/1.5) },
                ]"
            sizes="100vw"
            :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
            format="webp"
            :exposeOnly="exposeOnly"
            as="source"
    />
    <media-source
            :uri="imgUri"
            :dimensions="[
                    { width: 3840, height: 2560 },
                    { width: 2560, height: Math.round(2560/1.5) },
                    { width: 1920, height: Math.round(1920/1.5) },
                    { width: 1400, height: Math.round(1400/1.5) },
                ]"
            sizes="100vw"
            :media="`(min-width: ${config.ui.breakpoints.tablet.width}px)`"
            format="jpg"
            :exposeOnly="exposeOnly"
            as="source"
    />

    <media-source
            :uri="imgUri"
            :dimensions="[
                    { width: 1920, height: Math.round(1920/0.45) },
                    { width: 1200, height: Math.round(1200/0.45) },
                    { width: 720, height: Math.round(720/0.45) },
                ]"
            sizes="100vw"
            :exposeOnly="exposeOnly"
            format="webp"
            as="source"
    />

    <media-source
            :uri="imgUri"
            :dimensions="[
                    { width: 1920, height: Math.round(1920/0.45) },
                    { width: 1200, height: Math.round(1200/0.45) },
                    { width: 720, height: Math.round(720/0.45) },
                ]"
            sizes="100vw"
            format="jpg"
            as="img"
            class="w-full h-full object-cover relative z-1"
            :exposeOnly="exposeOnly"
            :loading="lazy ? 'lazy' : 'eager'"
    />
    <span
        :class="{
            'opacity-75': isLoaded,
            'opacity-100': !isLoaded
        }"
        class="bg-white transition-opacity duration-500 absolute inset-0 m-auto block z-2 w-full h-full"
    />
  </picture>
</template>
<script setup lang="ts">
const { imgUri, lazy = false, exposeOnly = false } = defineProps<{
    imgUri: string,
    lazy?: boolean
    darken?: boolean,
    exposeOnly?: boolean
}>();

const emit = defineEmits<{
    (e: 'load'): void
}>();

const isLoaded = ref<boolean>(false);

const pictureRef = ref<HTMLElement | null>(null);
let imgLoadHandler: ((this: GlobalEventHandlers, ev: Event) => any) | null = null;

function triggerIsLoaded(): void {
    isLoaded.value = true;
    emit('load');
}

onMounted(() => {
    const img = pictureRef.value?.querySelector('img') as HTMLImageElement | null;
    if (!img) return;

    // If already loaded (from cache), emit immediately
    if (img.complete && img.naturalWidth !== 0) {
        triggerIsLoaded();
        return;
    }

    imgLoadHandler = () => triggerIsLoaded();
    img.addEventListener('load', imgLoadHandler);
});

onBeforeUnmount(() => {
    const img = pictureRef.value?.querySelector('img') as HTMLImageElement | null;
    if (img && imgLoadHandler) img.removeEventListener('load', imgLoadHandler);
});


const config = useRuntimeConfig().public;
</script>